import DDLogs from '@/DDLogs';
import IlReFinanceResendButton from './IlReFinanceResendButton.vue';

function initializeIlReFinanceResendIntegration() {
  if (typeof window === 'undefined') {
    return;
  }
  if (!window.IlReFinanceResendComponentRegistry) {
    setTimeout(() => initializeIlReFinanceResendIntegration(), 100);
    return;
  }
  try {
    window.IlReFinanceResendComponentRegistry.register(IlReFinanceResendButton);
  } catch (error) {
    DDLogs.error('Failed to register IlReFinanceResend component', { error });
  }
}

if (typeof window !== 'undefined') {
  setTimeout(() => initializeIlReFinanceResendIntegration(), 0);
}
